import { Link } from 'react-router-dom';

import Router from "./Router";
import ScrollToTop from './ScrollToTop.js';

import linkedin from '../assets/logos/linkedin.webp';
import github from '../assets/logos/github.webp';
import orcid from '../assets/logos/ORCID.png';
import resumeFile from '../assets/files/resume.pdf';

export default function Layout({ children, pageIndex }) {
    return (
        <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
            <ScrollToTop />

            <Router pageIndex={pageIndex ?? 0} />

            <main className='growToEnd'>
                {children}
            </main>


            <footer>


                <div className='footer-wrapper'>
                    {/* <p style={{ color: 'white', fontSize: '14px', textAlign: 'center', display: 'block' }}>
                        <Link to="/contact" className='footer-link'>Contact</Link> | <a href='https://www.linkedin.com/in/michael-p-reidy/' className='footer-link'>Linkedin</a> | <a href='https://github.com/notred27' className='footer-link'>GitHub </a>
                    </p> */}


                    <div>
                        <Link to={'/'} style={{ textDecoration: "none" }}><span id="routerLogo">mReidy</span><span id="routerLogo" style={{ color: "var(--purple-accent)" }}>.</span><span id="routerLogo" style={{ fontSize: "1rem" }}>com</span></Link>

                    </div>
                    <div>


                        <div className="hero-links" style={{ justifyContent: "right" }}>
                            <a href="https://github.com/notred27" className="hero-icon-link" aria-label="GitHub">
                                <img src={github} alt="" className="hero-icon-img" />
                            </a>
                            <a href="https://www.linkedin.com/in/michael-p-reidy/" className="hero-icon-link" aria-label="LinkedIn">
                                <img src={linkedin} alt="" className="hero-icon-img" />
                            </a>
                            <a href="https://orcid.org/0009-0002-6850-032X" className="hero-icon-link" aria-label="ORCID">
                                <img src={orcid} alt="" className="hero-icon-img" />
                            </a>
                            <a href={resumeFile} className="hero-icon-link" aria-label="Resume">
                                <ion-icon name="document-text-outline" style={{ fontSize: '24px', color: 'white' }} />
                            </a>

                        </div>
                        <p style={{ textAlign: "right" }}>
                            <i>Created with A LOT of caffeine.</i>
                            <br />
                            © 2026 Michael Reidy.
                        </p>


                    </div>

                </div>


            </footer>
        </div>
    );
}
